<template>
  <MenuItems :items="menuItems"/>
</template>

<script>
import MenuItems from '../../components/MenuItems.vue'
export default {
    components:{
        MenuItems
    },
    data: ()=>({
        menuItems: [
            {
                title: "Acceso de Entidades",
                icon: "fas fa-list-ol",
                url: "/acceso/entidades",
            },
            {
                title: "Usuarios Registrados",
                icon: "fas fa-file-invoice",
                url: "/acceso/usuarios",
            }
        ]        
    })
}
</script>

<style>

</style>